let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("490Jr")]).then(() => parcelRequire('go9q2'));